import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-gray-800 text-white" data-id="element-18">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-20">
          <div data-id="element-21">
            <h3 className="text-lg font-semibold mb-4" data-id="element-22">Tu Nueva Vida</h3>
            <p className="text-gray-300" data-id="element-23">
              Redescubre el retiro con nuestro juego de mesa transformador.
            </p>
          </div>
          <div data-id="element-24">
            <h3 className="text-lg font-semibold mb-4" data-id="element-25">Enlaces</h3>
            <ul className="space-y-2" data-id="element-26">
              <li data-id="element-27">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-28">
                  Inicio
                </Link>
              </li>
              <li data-id="element-29">
                <Link to="/registro" className="text-gray-300 hover:text-white" data-id="element-30">
                  Registro
                </Link>
              </li>
              <li data-id="element-31">
                <Link to="/manual" className="text-gray-300 hover:text-white" data-id="element-32">
                  Manual
                </Link>
              </li>
              <li data-id="element-33">
                <Link to="/comunidad" className="text-gray-300 hover:text-white" data-id="element-34">
                  Comunidad
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-35">
            <h3 className="text-lg font-semibold mb-4" data-id="element-36">Contacto</h3>
            <p className="text-gray-300" data-id="element-37">
              ¿Tienes preguntas? Escríbenos a <br data-id="element-38" />
              <a href="mailto:info@tunuevavida.com" className="hover:text-white" data-id="element-39">
                info@tunuevavida.com
              </a>
            </p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-300" data-id="element-40">
          <p data-id="element-41">
            &copy; {new Date().getFullYear()} Tu Nueva Vida. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;